import customFetch from "../helpers/customFetch";
import { URL_EXACTIAN, getConfigExactian } from "../helpers/helpers";

export const getAccessUsersService = async () => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/users/AccessUsers`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}
